export const CHART_CONSTANTS = {
  IMAGE_SIZE: 50,
  TEXT_HEIGHT: 20,
  BORDER_RADIUS: 8,
  PADDING: 10,
  FONT: "12px Arial",
  TEXT_COLOR: "#999999",
  SQUARE_SIZE: 46,
};
